import styled from 'styled-components';
import { Anchor, Flex, FONT_TYPES, spaceMixin, token, typographyMixin } from '@zillow/constellation';

import { MUIBreakpointLg, MUIBreakpointMd, MUIBreakpointXl } from './constants';

export const StyledHeaderNavigationWrapper = styled.nav`
  background: ${token('colors.white')};
  border-bottom: 1px solid ${token('colors.gray300')};

  // reponsive container sets position. resetting the position here
  .HeaderNavigation-container {
    position: unset;
  }
`;

export const StyledFlex = styled(Flex)`
  height: 55px;
  margin: auto;
  position: relative;

  @media screen and (min-width: ${MUIBreakpointLg}) {
    height: 81px;
  }

  @media screen and (min-width: ${MUIBreakpointXl}) {
    padding: 0;
  }

  .HeaderNavigation-sectionLeft {
    width: 33%;

    .HeaderNavigation-sectionLeft-mobile {
      display: block;

      @media screen and (min-width: ${MUIBreakpointLg}) {
        display: none;
      }
    }

    .HeaderNavigation-sectionLeft-desktop {
      display: none;

      @media screen and (min-width: ${MUIBreakpointLg}) {
        display: block;
      }
    }
  }

  .HeaderNavigation-sectionMiddle {
    .HeaderNavigation-sectionMiddle-mobile {
      padding: ${spaceMixin('sm')} 0;
      display: block;

      @media screen and (min-width: ${MUIBreakpointLg}) {
        display: none;
      }
    }

    .HeaderNavigation-sectionMiddle-desktop {
      display: none;

      @media screen and (min-width: ${MUIBreakpointLg}) {
        display: block;
      }
    }
  }

  .HeaderNavigation-sectionRight {
    width: 33%;
  }
`;

export const StyledMenuItemAnchor = styled(Anchor)`
  && {
    display: inline-block;
    text-decoration: none;
    ${(props) => typographyMixin({ ...props, fontType: FONT_TYPES.body })}
    color: ${token('colors.gray600')};
  }

  &&:visited {
    color: ${token('colors.gray600')};
  }

  &&:active {
    text-decoration: none;
  }

  &&:hover {
    color: ${token('colors.blue400')};
    font-weight: 600;
  }

  &&:before {
    content: attr(title);
    display: block;
    font-weight: 600;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
`;

export const StyledMessageTab = styled.div`
  position: relative;
  & .Link {
    display: flex;
  }
  & .HeaderNav-msg-text {
    flex: 1;
  }
  & .HeaderNav-msg-count {
    font-weight: bold;
    padding: 0 12px;
    height: 22px;
    background-color: #e96e2f;
    text-align: center;
    color: white;
    margin-left: 4px;
    border-radius: 11px;
    text-decoration: underline;
    text-decoration-color: #e96e2f;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-right: 4px;
    &:hover {
      color: white;
    }
    @media screen and (min-width: ${MUIBreakpointMd}) {
      margin-right: 0;
    }
  }
`;
